export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyA1qS16FAzV8L117h8Bl3LEJihtPHCennw", // FOR HOSTING
    // apiKey: 'AIzaSyDzdZZEKt38xvcyxzIEto7Uy9BqKLrMtuU',   // FOR DEVELOPMENT (2 IP)
    authDomain: "adaptiveservicedev.firebaseapp.com",
    databaseURL: "https://adaptiveservicedev.firebaseio.com",
    projectId: "adaptiveservicedev",
    storageBucket: "adaptiveservicedev.appspot.com",
    messagingSenderId: "941408712920",
    appId: "1:941408712920:web:70478081111e876e8e7fad",
  },
  recaptchaV3SiteKey: "6LfW0yctAAAAABckMLZeQeFu0oOJON884oKxvkkL",
  recaptchaV3DebugKey: "EAF150E8-BB6B-4FF5-B762-7D132770F3DB",
};

export const API_URL = "https://devapi.adaptive-cloud.pl/api/";
